<template>
  <div v-if="!data.provider.isConnected || data.list.length > 0" class="search-list-title">
    <div class="search-list-title-detail">
      <img src="@assets/svgs/preload-icon-file.png" alt="" />
      <span class="search-list-title-detail-name">{{ data.provider.sourceName }}</span>
      <span class="search-list-title-detail-device">{{ data.provider.name }}</span>
    </div>
    <div v-if="!data.provider.isConnected" class="connect-device">
      {{ $t('owork_base.equipment_offline') }}
      <span @click="showConnectPopper">{{ $t('owork_base.click_to_connect') }}</span>
    </div>
  </div>
  <div
    v-for="(item, index) in data.list"
    :key="data.provider.id + index"
    :class="['search-list-item', { active: item.active }]"
    @click="onclickSearchItem(item)"
    @dblclick="openSearchItem(item)"
  >
    <img :src="getIconBySuffix(item.filename, item.type)" alt="" />
    <span class="search-list-file-name" v-html="item._filename ?? item.filename"></span>
  </div>
</template>
<script lang="ts" setup>
  import { useOtrack } from '@/core/compositions/Otrack'
  import { INSTANCE as DevicePullUpTaskManager } from '@/core/DevicePull/DevicePullUpTaskManager'
  import { TrackEventMap } from '@/core/TrackConstants'
  import type { SearchResultListItem, SearchResponseData } from '@core/search/SearchProvider'
  import { getIconBySuffix } from '../fileutil/FileIconHelper'
  import { OpenableFileList } from './SearchResultsHandle'

  const { track } = useOtrack()

  const props = defineProps<{
    data: SearchResponseData
  }>()

  const emit = defineEmits(['onclick-search-item', 'open'])

  const showConnectPopper = () => {
    DevicePullUpTaskManager.pullUpDevice({ deviceId: props.data.provider.id }, undefined, true, true)
    track({ eventId: TrackEventMap.PULL_UP_DEVICE_FROM_SEARCH_COMPONENT })
  }

  const onclickSearchItem = (item: SearchResultListItem) => {
    emit('onclick-search-item', item, props.data.provider.id)
  }

  const openSearchItem = (item: SearchResultListItem) => {
    if (OpenableFileList.includes(item.type)) emit('open', item)
  }
</script>
<style scoped lang="stylus">

  .search-list-title
    flex-align-center(space-between)
    height 36px
    .search-list-title-detail
      flex-align-center()
      & > img
        rect(20px)
      .search-list-title-detail-name
        margin-left 8px
        title()
      .search-list-title-detail-device
        font-size 12px
        margin-left 12px
        padding 3px 6px
        background linear-gradient(0deg, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.06)), #ffffff
        border-radius 4px
        sub-title()
        max-width 100px
        ellipsis()
    .connect-device
      font-size 12px
      color default_shallow_color
      & > span
        color active_color
        cursor pointer
  .search-list-item
    height 36px
    flex-align-center()
    padding-left 28px
    cursor pointer
    border-radius 8px
    margin-top 8px
    &:hover
      background-color rgba(84, 86, 104, 0.04)
    & > span
      color default_color
      ellipsis()
    & > img
      margin-right 8px
      rect(20px)
  .active
    background-color #ffffff

  @import '../styles/h5Adaptive/SearchInputComponent.styl'
</style>
